import { AUTH_REDUCER_KEY } from 'store/auth/constants'

export const tenantFromState = state => state[AUTH_REDUCER_KEY].tenant.id
export const tenantListFromState = state => state[AUTH_REDUCER_KEY].tenant.all
export const tenantLoadingFromState = state => state[AUTH_REDUCER_KEY].tenant.loading
export const isParent = state => state[AUTH_REDUCER_KEY].tenant.isParent
export const subTenants = state => state[AUTH_REDUCER_KEY].tenant.subTenants
